<template>
  <a-modal 
    :visible="visible" 
    title="预览营养需要量"
    v-if="visible"
    @cancel="cancel"
    @afterClose="cancel"
    :footer="false"
    :maskClosable="false"
    width="800px"
  >
    <a-table 
      bordered
      :pagination="false"
      :scroll="{y: 400}"
      :dataSource="list"
      :columns="columns"
    >
    <template slot="fixed2" slot-scope="t,r">
      {{ t || t === 0 ? Number(t).toFixed(len(r)) : '' }}
    </template>
    </a-table>
  </a-modal>
</template>

<script>
export default {
  props: ['visible','materialList','detail'],
  data() {
    return {
      list: [],
      columns:[
        {
          title:"指标名称",
          dataIndex:'name',
          width: 160,
          // scopedSlots: {customRender: 'productName'},
          // sorter: (a, b) => a.productCode.localeCompare(b.productName,'zh'),
        },
        {
          title:"指标全称",
          dataIndex:'fullName',
          width: 160,
        },
        {
          title:"数值",
          dataIndex:'content',
          width: 100,
          scopedSlots: {customRender: 'fixed2'},
        },
        {
          title:"单位",
          dataIndex:'unit',
          width: 100,
        },
      ]
    }
  },
  computed: {
    totalWeight() {
      let s = this.materialList.find(el => el.rawName === '合计') || {}
      return s.uasge || ''
    },
    formulaRawProductDTOList(){
      let list = this.materialList.filter(el => el.rawName !== '合计' && (el.percentage || el.percentage === 0))
      return list || []
    },
  },
  watch: {
    visible(val){
      if(val) this.getList()
    }
  },
  methods: {
    len(record){
      let len = 2
      if(record.unit ==='MJ' || record.unit === 'Kcal') len = 0
      return len
    },
    cancel() {
      this.$emit('close')
    },
    async getList() {
      let formulaRawProductDTOList = JSON.parse(JSON.stringify(this.formulaRawProductDTOList))
      formulaRawProductDTOList && formulaRawProductDTOList.map(el => {
        el.rawName = undefined
        el.name = undefined
        return el
      })
      let params = {
        productId: this.detail.id,
        totalWeight: this.totalWeight,
        productName: this.detail.productName,
        formulaRawProductDTOList
      }
      this.$http.post('/nhf-app/formulaproduct/preViewProNutrition',params).then(res => {
        let {success,data,msg} = res || {}
        // if(success) this.list = data || []
        if(success){
          this.list = data || []
        }else{
          this.$error({
            title: '预览失败',
            content: msg,
            okText: '知道了'
          })
        }
      })
    }
  }
}
</script>